import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { MessageService } from './message.service';

@Injectable({
    providedIn: 'root'
  })
export class BaseService {


    http: HttpClient;
    messageService: MessageService;



    constructor(http: HttpClient, messageService: MessageService) {
        this.http = http;
        this.messageService = messageService;
    }

    dataGET<T>(url): Observable<T> {
        var o = { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.getCookie("_galis_access_token"), 'Content-Type': 'application/json' }) };
        return this.http.get<T>(url, o)
    }

    dataPOST<T>(url, data): Observable<T> {
        var o = { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.getCookie("_galis_access_token"), 'Content-Type': 'application/json' }) };
        return this.http.post<T>(url, data, o);
    }


    public getToken():string
    {
        var token = this.getCookie("_galis_access_token");
        return token;
    }
  
    public setToken(token:string){
  
        this.setCookie("_galis_access_token", token, 1);
    }

    public getCookie(name: string) {
      let localStorageValue = localStorage.getItem(name);
      let ca: Array<string> = localStorageValue.split(';');
      let caLen: number = ca.length;
        let cookieName = `${name}=`;
        let c: string;

        for (let i: number = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) == 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
    }

    private setCookie(name: string, value: string, expireDays: number, path: string = '') {
      let d: Date = new Date();
      d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
      let expires: string = `expires=${d.toUTCString()}`;
      let cpath: string = path ? `; path=${path}` : '';
      let cookieValue = `${name}=${value}; ${expires}${cpath}`;
      localStorage.setItem(name, cookieValue);
    }
}
